module.exports = __webpack_public_path__ + "img/stick_activites_divertissement.b623adcf.svg";